/* eslint-disable no-undef */
/**
 * @Author: nowThen
 * @Date: 2019-08-22 14:30:51
 */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = { // 要设置的全局访问的state对象
  userInfo: {
    id: 0
  },
  tabIndex: 'index',
  tabShow: false,
  showHeader: true,
  noAnswerList: [],
  answerList: [],
  minute: 0, // 已作答时间
  // 要设置的初始属性值
  editorConetnt: [] // 富文本输入缓存
};
const getters = { // 实时监听state值的变化(最新状态)
  userInfo(state) { // 方法名随意,主要是来承载变化的showFooter的值
    return state.userInfo
  },
  tabIndex(state) {
    return state.tabIndex
  },
  tabShow(state) {
    return state.tabShow
  },
  showHeader(state) {
    return state.showHeader
  },
  noAnswerList(state) {
    return state.noAnswerList
  },
  answerList(state) {
    return state.answerList
  },
  minute(state) {
    return state.minute
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations: {
    setTabShow(states, condition) {
      states.tabShow = condition
    },
    SetShowHeader(states, condition) {
      states.showHeader = condition
    },
    setNoAnswerList(states, condition) {
      states.noAnswerList = condition
    },
    setAnswerList(states, condition) {
      states.answerList = condition
    },
    setMinute(states, condition) {
      states.minute = condition
    },
    setEditorConetnt(states, { index, value }) {
      states.editorConetnt[index] = value
    },
    clearEditorConetnt(states) {
      states.editorConetnt = []
    }
  },
  actions: {

  }
})
